import lodash from 'lodash';

import {EASINGS} from '../../ecs/easingHelper';
import easeInRightGif from '../../../assets/images/transitions/easeInRight.gif';

/**
 * The name that signals this preset.
 * @const {string}
 */
export const PRESET_EASE_OUT_RIGHT = 'easeOutRight';

/**
 * The preset details.
 *
 * @type {{
 *   name: string,
 *   humanName: string,
 *   flow: string,
 *   details: Object.<string, {
 *     easing: string,
 *     parse: boolean,
 *     values: *|Array.<*>,
 *     time: {start: (string|number), end: (string|number)}
 *   }>,
 *   template: {}
 * }}
 */
export const easeOutRightPresetDetails = {
  // The name of the preset.
  name: PRESET_EASE_OUT_RIGHT,

  // A human friendly name for the preset.
  humanName: 'Ease Out & Rotate to Right',

  // A preview of the transition.
  gif: easeInRightGif,

  // The element names that this preset can be used for or true for all elements.
  elements: true,

  // The preset direction: in, out, middle. This is used in the UI logic.
  flow: 'out',

  // Each property that will change during the transition.
  details: {
    'position.x': {
      time: {
        start: 'end.-1000',
        end: 'end.0'
      },
      easing: EASINGS.easeInPower3,
      values: [
        'position.right',
        'off.right'
      ],
      immediateRender: false
    },
    'transform.rotate': {
      time: {
        start: 'end.-1000',
        end: 'end.0'
      },
      easing: EASINGS.easeInPower3,
      values: [
        '0',
        '90'
      ],
      immediateRender: false
    },
  },

  // How this preset can be used in the source (including optional parameters).
  // This will be turned into a JSON string, so no functions can be used.
  template: {
    preset: PRESET_EASE_OUT_RIGHT,
    options: {},
  },
};

easeOutRightPresetDetails.template.options = lodash.cloneDeep(easeOutRightPresetDetails.details);

// This defines the key in the presets object.
export const presetName = PRESET_EASE_OUT_RIGHT;

// This defines the value of the presets object.
export default easeOutRightPresetDetails;
